import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=7cdd43ef&"
import script from "./scoreboard.vue?vue&type=script&lang=js&"
export * from "./scoreboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
